import React, { useState } from 'react';
import SchoolEditor from './SchoolEditor';
import SchoolIcon from '@mui/icons-material/School';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import 'styles/index.css';

function Schools({ education, onSave, onDelete, onReorder }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editingSchool, setEditingSchool] = useState({});

  const handleSaveSchool = (schoolForm) => {
    setIsEditing(false);
    onSave(schoolForm);
  }

  const handleDeleteSchool = (id) => {
    setIsEditing(false);
    onDelete(id);
  }

  const handleCancel = () => {
    setIsEditing(false);
  }

  const handleEditSchool = (index) => {
    setIsEditing(true);
    const foundSchool = education.find(obj => obj.id === index);
    setEditingSchool(foundSchool);
  }

  const handleAddSchool = () => {
    setIsEditing(true);
    setEditingSchool({});
  }

  const handleMoveUp = (index, e) => {
    e.stopPropagation();
    if (index > 0) {
      onReorder(index, index - 1);
    }
  }

  const handleMoveDown = (index, e) => {
    e.stopPropagation();
    if (index < education.length - 1) {
      onReorder(index, index + 1);
    }
  }

  const editingForm = (
    <div className="px-4 pb-4">
      <SchoolEditor editingSchool={editingSchool} onSave={handleSaveSchool} onDelete={handleDeleteSchool} onCancel={handleCancel}/>
    </div>
  );

  return (
    <div className="form-container">
      <div className="form-text-main">{"Education"}</div>
      {isEditing && editingForm}

      {!isEditing && (
        <div>
          {education.map((school, index) => (
            <div key={`school-${index}`} 
              className="form-secondary-area flex items-center" 
              onClick={() => handleEditSchool(school.id)}
            >
              <div className="flex items-center gap-2 mr-4">
                <button 
                  className="p-1 hover:bg-gray-100 rounded"
                  onClick={(e) => handleMoveUp(index, e)}
                  disabled={index === 0}
                >
                  <KeyboardArrowUpIcon />
                </button>
                <button 
                  className="p-1 hover:bg-gray-100 rounded"
                  onClick={(e) => handleMoveDown(index, e)}
                  disabled={index === education.length - 1}
                >
                  <KeyboardArrowDownIcon />
                </button>
              </div>
              <div className="flex-grow">
                <div className="font-bold">
                  {school.institution}
                </div>
                <div>
                  {school.area}
                </div>
              </div>
              <button 
                className="green-button px-6 py-2 border border-1 min-w-[100px]" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditSchool(school.id);
                }}
              >
                {"Edit"}
              </button>
            </div>
          ))}
          <div className={`p-4 flex flex-col items-center justify-center add-button`} onClick={handleAddSchool}>
            <SchoolIcon fontSize="large"/>
            <span>{"Add School"}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Schools;
